import jwtDecode from 'jwt-decode';

export const TOKEN_KEYS = Object.freeze({
    GROUPS: 'https://allstate/user/groups',
    USER_ID: 'https://allstate/user/username'
});

class OAuthTokenSingleton {
    initialize(token) {
        this.encodedToken = (token) || null;
        this.decodedToken = (token) ? jwtDecode(token) : null;
    }

    getEncodedToken() {
        return this.encodedToken;
    }

    getDecodedToken() {
        return this.decodedToken;
    }

}

export const OAuthToken = new OAuthTokenSingleton();
